import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import { AnnotationTagFragmentDoc } from "../../fragments/annotationTag.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpsertAnnotationTagMutationVariables = Types.Exact<{
  payload: Types.AnnotationTagInput;
}>;

export type UpsertAnnotationTagMutation = {
  __typename?: "Mutation";
  upsertAnnotationTag: {
    __typename?: "AnnotationTag";
    id: string;
    tag: string;
    color: string;
    description: string;
  };
};

export const UpsertAnnotationTagDocument = gql`
  mutation upsertAnnotationTag($payload: AnnotationTagInput!) {
    upsertAnnotationTag(payload: $payload) {
      ...AnnotationTag
    }
  }
  ${AnnotationTagFragmentDoc}
`;
export type UpsertAnnotationTagMutationFn = Apollo.MutationFunction<
  UpsertAnnotationTagMutation,
  UpsertAnnotationTagMutationVariables
>;

/**
 * __useUpsertAnnotationTagMutation__
 *
 * To run a mutation, you first call `useUpsertAnnotationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAnnotationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAnnotationTagMutation, { data, loading, error }] = useUpsertAnnotationTagMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpsertAnnotationTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertAnnotationTagMutation,
    UpsertAnnotationTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertAnnotationTagMutation,
    UpsertAnnotationTagMutationVariables
  >(UpsertAnnotationTagDocument, options);
}
export type UpsertAnnotationTagMutationHookResult = ReturnType<
  typeof useUpsertAnnotationTagMutation
>;
export type UpsertAnnotationTagMutationResult =
  Apollo.MutationResult<UpsertAnnotationTagMutation>;
export type UpsertAnnotationTagMutationOptions = Apollo.BaseMutationOptions<
  UpsertAnnotationTagMutation,
  UpsertAnnotationTagMutationVariables
>;
